// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3K4Fw","option":"styles_option__3qFpR","active":"styles_active__3syfQ"};